export const WELCOME_ACTIONS = {
  SET_WELCOME_MESSAGE: 'setWelcomeMessage',
  DISMISS_WELCOME_MESSAGE: 'dismissWelcomeMessage'
} as const

export type WelcomeActionType = (typeof WELCOME_ACTIONS)[keyof typeof WELCOME_ACTIONS]
